export enum ECreditAdjustmentReason {
    BUG = 'bug',
    COMMERCIAL_GESTURE = 'commercial_gesture',
    CORRECTION = 'correction',
    OTHER = 'other',
}

// Shown to the client in the consumption history, keep it customer-facing
export const creditAdjustmentReasonAsString = (reason: ECreditAdjustmentReason | string): string => {
    switch (reason) {
        case ECreditAdjustmentReason.BUG:
            return "Correction suite à un incident";
        case ECreditAdjustmentReason.COMMERCIAL_GESTURE:
            return "Geste commercial";
        case ECreditAdjustmentReason.CORRECTION:
            return "Régularisation";
        case ECreditAdjustmentReason.OTHER:
        default:
            return "Ajustement";
    }
};